import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const navLinks = [
  { href: '#hero', label: 'Início' },
  { href: '#desafios', label: 'Desafios' },
  { href: '/plataforma', label: 'Plataforma', external: true },
  { href: '#resultados', label: 'Resultados' },
  { href: '#planos', label: 'Planos' },
  { href: '#casos', label: 'Casos' },
  { href: '#contato', label: 'Contato' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const handleNav = (e, href, external) => {
    if (external) return;
    e.preventDefault();
    if (isHome) {
      document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  };

  const handleNavMobile = (e, href, external) => {
    setMenuOpen(false);
    if (external) return;
    handleNav(e, href, false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="/"
            onClick={e => handleNav(e, '#hero', false)}
          >
            <img
              src="https://i.postimg.cc/1tVqPD4T/Prancheta-8-8.png"
              alt="Nexus"
              className={`h-9 w-auto object-contain transition-all duration-300 ${!scrolled ? 'brightness-0 invert' : ''}`}
            />
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map(({ href, label, external }) => (
              <a
                key={href}
                href={href}
                onClick={e => handleNav(e, href, external)}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                  scrolled
                    ? 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="/admin"
              className={`text-sm font-medium px-4 py-2 rounded-lg transition-all duration-200 ${
                scrolled ? 'text-gray-500 hover:text-blue-600' : 'text-white/70 hover:text-white'
              }`}
            >
              Login
            </a>
            <a
              href="#contato"
              onClick={e => handleNav(e, '#contato', false)}
              className="text-sm font-semibold px-5 py-2.5 bg-blue-900 text-white rounded-lg hover:bg-blue-800 transition-all duration-200 shadow-sm"
            >
              Falar com especialista
            </a>
          </div>

          <button
            onClick={() => setMenuOpen(o => !o)}
            className={`md:hidden p-2 rounded-lg transition-colors ${scrolled ? 'text-gray-700' : 'text-white'}`}
            aria-label="Menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              }
            </svg>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-6 py-4 space-y-1">
            {navLinks.map(({ href, label, external }) => (
              <a
                key={href}
                href={href}
                onClick={e => handleNavMobile(e, href, external)}
                className="block px-4 py-3 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              >
                {label}
              </a>
            ))}
            <div className="pt-3 border-t border-gray-100 space-y-2">
              <a
                href="/admin"
                className="block text-center text-sm font-medium px-5 py-2.5 text-gray-600 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors"
              >
                Login
              </a>
              <a
                href="#contato"
                onClick={e => handleNavMobile(e, '#contato', false)}
                className="block text-center text-sm font-semibold px-5 py-3 bg-blue-900 text-white rounded-lg hover:bg-blue-800 transition-colors"
              >
                Falar com especialista
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
